<template functional>
  <component
    :is="$options.components.CommonChip"
    dark
    :color="props.setClass === 'static' ? 'rust' : 'green'"
    :class="[
      data.class || '',
      data.staticClass || '',
    ]"
    v-bind="data.attrs"
    v-on="data.on"
  >
    {{ props.setClass === 'static' ? 'Static Set' : 'Filter Set' }}
  </component>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';

import { Nullable } from '@/utils/types';

import CommonChip from '@/bundles/Common/components/chips/CommonChip.vue';

export default Vue.extend({
  name: 'SavedSetTypeChip',

  components: { CommonChip },

  props: {
    setClass: {
      type: String as PropType<Nullable<string>>,
      default: null,
    },
  },
});
</script>
